'use client'

import { useParams } from 'next/navigation'
import { useEffect, useState } from 'react'
import { useIsClient } from 'usehooks-ts'

const getHash = () => window.location.hash

const useHash = () => {
  const isClient = useIsClient()
  const [hash, setHash] = useState(isClient ? getHash() : null)
  const params = useParams()

  useEffect(() => {
    if (isClient) {
      setHash(getHash())
    }
  }, [params, isClient])

  return isClient ? hash : null
}

export default useHash
